import Ranking from '../components/ranking/Ranking';

export default function RankingTest() {
  return (
    <>
      <Ranking number={1} />
      <Ranking number={2} />
      <Ranking number={3} />
    </>
  );
}
